<template>
    <v-img ref="headerImgMain" :src="require(`@/assets/headers/${headerImage}`)" height="86" :gradient="headerGradient">
        <v-toolbar class="transparent" flat>
            <h3 class="subheading white--text" :style="page_header_class">{{title}} <span v-if="title && page_title && !isMainMenu">></span><span v-if="page_title && !isMainMenu"> {{page_title}}</span></h3>
            <v-toolbar-title class="transparent"></v-toolbar-title>
            <v-spacer></v-spacer>
            <img v-if="avatarPath" ref="avatar" :src="avatarPath" :class="isMobile?'avatar-mobile':'avatar'" >
            <img v-if="companyLogo" ref="companyLogoRef" :src="`${companyLogo}?date=${Date.now()}`" :class="isMobile?'company-logo-mobile':'company-logo'" >
        </v-toolbar>
        <div v-if="isMainMenu" class="headline white--text" :style="page_title_class">{{page_title}}</div>
    </v-img>
</template>
<script>

import commonfn from '@/common/functions'
export default {
    components: {},
    data() {
        return {
            headerImage: '',
            dialog: false,
            headerGradientValues: [
                { name: 'default', value: 'to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)' },
                { name: 'blue', value: 'to right, rgba(25, 118, 210, 0.5), rgba(0, 0, 0, 0.2)' },
                { name: 'green', value: 'to right, rgba(76, 175, 80, 0.5), rgba(0, 0, 0, 0.4)' },
                { name: 'cyan', value: 'to right, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.5)' },
                { name: 'purple', value: 'to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5)' },
                { name: 'brown', value: 'to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)' },
                { name: 'bluegrey', value: 'to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)' },
                { name: 'grey', value: 'to right, rgba(100, 0, 0, 0), rgba(0, 0, 0, 0)' }
            ]
        }
    },
    props: ['title', 'page_title', 'helpsubject','avatarPath','companyLogo','isMainMenu'],
    methods: {     
        setHeaderImageMain() {
            this.headerImage = this.formatHeaderImage(this.$store.state.headerImg) 
            this.$refs.headerImgMain.src = `@/assets/headers/${this.headerImage}?date=${Date.now()}`
        },
        bindRootEventHandlers() {
            this.$root.$on('updateHeaderAvatar', (data) => {
                if (data=='updateHeaderAvatarHandler') {
                    this.$refs.avatar.src = this.$store.state.avatar
                }
            })
            this.$root.$on('updateHeaderCompanyLogo', (data) => {
                if (data=='updateHeaderCompanyLogoHandler') {
                    this.$refs.companyLogoRef.src = commonfn.getCompanyLogoUrl()
                }
            })
        },
        formatHeaderImage(imgFileName) {
            return imgFileName.toLowerCase().replace('.darken1','').replace('.darken2','').replace('.darken3','').replace('.darken4','')  
        },
    },
    computed: {     
        isMobile() {
            return window.innerWidth < 600
        },
        page_title_class() {
            if (this.isMobile) return 'margin:0px 0px 5px 21px;'
            else return 'margin:-10px 0px 5px 24px;'
        },
        page_header_class() {
            if (this.isMobile) return 'margin:0px 0px 0px 5px;'
            else return 'margin:-15px 0px 0px 0px;'
        },
        savedCompanyLogo() {
            if (this.$store.state.companyLogo) return this.$store.state.companyLogo
            return 'default.png'
        },
        headerGradient() {
            const header = this.headerImage.split('.')[0]
            if (header)
                return this.headerGradientValues.find(x => x.name == header).value
            
            return this.headerGradientValues.find(x => x.name == 'default').value
        }
    },
    created() {
        this.bindRootEventHandlers() 
        this.headerImage = this.formatHeaderImage(this.$store.state.headerImg)
    },
}
</script>
<style>
  .avatar-mobile {
    border-radius:5px;
    margin-top:45px;
    height:60px;
    width:60px
  }
  .avatar {
    border-radius:5px;
    margin-top:30px;
    height:70px;
    width:70px
  }
  .company-logo-mobile {
    border-radius:5px;
    margin-top:45px;
    height:60px;
    width:60px
  }
  .company-logo {
    border-radius:5px;
    margin-top:30px;
    height:70px;
    width:70px
  }
</style>